import dayjs from "dayjs";
import type {EventCreateDtoInput} from "../../GraphQL/generated/graphql";

type EventCreateRequiredBaseFields = {
    nameHr: string;
    nameEn: string;
    place: string;
    address: string;
    eventInformationHr: string;
    eventInformationEn: string;
    onSiteRegistrationInstructionsHr: string;
    onSiteRegistrationInstructionsEn: string;
    hasParticipationFee: boolean;
};

export type EventCreateFormData = EventCreateDtoInput & EventCreateRequiredBaseFields;
export type EventCreatePayload = EventCreateDtoInput & EventCreateRequiredBaseFields;

type DateInput = Date | string | number | undefined;

export const buildEventCreateDto = (values: EventCreateFormData): EventCreatePayload => ({
    code: values.code?.trim() || `EVENT-${dayjs().format("YYYYMMDDHHmmssSSS")}`,
    name: values.name,
    nameHr: values.nameHr,
    nameEn: values.nameEn,
    place: values.place,
    address: values.address,
    eventInformationHr: values.eventInformationHr,
    eventInformationEn: values.eventInformationEn,
    onSiteRegistrationInstructionsHr: values.onSiteRegistrationInstructionsHr,
    onSiteRegistrationInstructionsEn: values.onSiteRegistrationInstructionsEn,
    hasParticipationFee: values.hasParticipationFee,
    startDate: dayjs(values.startDate as DateInput).startOf("day").toISOString(),
    endDate: dayjs(values.endDate as DateInput).startOf("day").toISOString()
});
